// JS: added to avoid circular deps on global data, defined in RecPartAlgorithm

/// /// UtilContext ///////
export const ApContext = {
  /* Dimensions of the boxes to be packed. */
  // int l, w;
  l: null,
  w: null,
  // int **lowerBound, **upperBound;
  lowerBound: null,
  upperBound: null,
  /* Arrays of indices for indexing the matrices that store information
   * about rectangular subproblems (L,W), where (L,W) belongs to X' x Y'
   * and X' and Y' are the raster points sets associated to (L,l,w) and
   * (W,l,w), respectively. */
  // int *indexX, *indexY;
  indexX: null,
  indexY: null,
  /* Set of integer conic combinations of l and w:
   * X = {x | x = rl + sw, with r,w in Z and r,w >= 0} */
  // Set normalSetX;
  normalSetX: null,
  /* Indicate in which level of the recursion (or in which depth of the
   * tree search) the solution was found. Initially, solutionDepth[L][W]
   * = N, for all (L,W) subproblem. If the optimal solution was found
   * for a subproblem (L,W), than solutionDepth[L][W] = -1. */
  // int **solutionDepth;
  solutionDepth: null,
  /* Array that stores the normalized values of each integer between 0 and
   * L (dimension of the problem):
   * normalize[x] = max {r in X' | r <= x} */
  // int *normalize;
  normalize: null,
  /* Store the solutions of the subproblems. */
  // std::map<int, int> *solutionMap;
  solutionMap: null,
  // int *solution;
  solution: null,
  /* Store the division points in the rectangular and in the L-shaped
   * pieces associated to the solutions found. */
  // std::map<int, int> *divisionPointMap;
  divisionPointMap: null,
  // int *divisionPoint;
  divisionPoint: null,
  /* Store the points that determine the divisions of the rectangles. */
  // CutPoint **cutPoints;
  cutPoints: null, // JS: use util.newCutPoint()
  /* Indicate if the limit of the recursion was reached during the
   * resolution of a problem. */
  // int **reachedLimit;
  reachedLimit: null,
  // int *indexRasterX, *indexRasterY;
  indexRasterX: null,
  indexRasterY: null,
  // int numRasterX, numRasterY;
  numRasterX: 0,
  numRasterY: 0,
  /* Type of the structure used to store the solutions. */
  // int memory_type;
  memory_type: null
}
